<template>
<div>
  <nx-bform  v-if="!linkIAmSmart&&!isCompleted"
    ref="form"
    @submit="onSubmit"
    class="e-registration-owner-assign-form"
  >
    <h5>
      {{ $t("title") }}
    </h5>
    <!-- <p class="text-muted">
      {{ $t("titleDesc") }}
    </p> -->

    <div
      v-if="!isCompleted"
      class="mb-2"
      style="color:#dc3545;font-size: 80%;margin-top: 0.25rem;"
    >
      {{errorMsg}}
    </div>
    <div>
      <RegistrationHaveEshAcFormGroup
        label-cols="2"
        label-align="right"
        v-model="haveAc"
        required
      />

      <template v-if="haveAc">
        <RegistrationLoginNameFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.username"
          required
        />

        <RegistrationPasswordFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.password"
          required
        />

        <b-form-group label-cols="2">
          <b-button type="submit" variant="primary" v-t="'ownerLogin'" />
        </b-form-group>
      </template>
      <template v-else>
        <RegistrationLoginNameNewFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.username"
          required
        />

        <RegistrationNameTitleFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.title"
          required
        />

        <RegistrationFullNameFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.fullname"
      
        />

        <!-- <RegistrationEnglishNameFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.nameEng"
          required
        /> -->

        <RegistrationChineseNameFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.nameChinese"
        />

        <RegistrationContactAddressFormGroup
          label-cols="2"
          label-align="right"
          required
          v-model="form.address"
        />

        <RegistrationEmailFormGroup
          label-cols="2"
          label-align="right"
          required
          v-model="form.email"
        />

      <ManageCertFormGroup  label-align="right" :name="fullName" :guid="guid" @setFullName="setFullName"  label-cols="2" />

        <RegistrationLanguageFormGroup
          label-cols="2"
          label-align="right"
          required
          v-model="form.lang"
        />

        <CaptchaFormGroup
          label-cols="2"
          label-align="right"
          required
          v-model="form.captcha"
          @change-token="form.captchaToken = $event.token"
        />

        <hr />

        <ERegistrationPublicTermCond v-model="accepted" />
      
        <b-form-group label-cols="2">
          <b-button type="submit" variant="primary" v-t="'send'" />
          <b-button class="ml-2" @click="resetForm" v-t="'cancel'" />
        </b-form-group>
      </template>
    </div>
    <!--<div v-else style="color:red">
      <div v-if="result=='Expired'">
        {{ $t("InvitationExpired") }}
      </div>
      <div v-else-if="result=='NotFound'">
        {{ $t("InvitationNotFound") }}
      </div>      
      <div v-else-if="result=='Registered'">
        {{ $t("Registered") }}
      </div>  
    </div>-->        
  </nx-bform>
    <AfterRegisterCompleted v-if="isCompleted" :exist="true"  @useESS="useESS"/>
    </div>
</template>

<script>
import { upperCase } from "lodash";
import NxFormCaptcha from "@/components/NxFormCaptcha";
import ERegistrationPublicTermCond from "../ERegistrationPublicTermCond";
import { EshApi, MemberRegistrationApi, RequestRegistrationApi } from "@/api";
import { UserService } from "@/services";
import { FileUtil, UserApi } from "nx-libs";
import RegistrationHaveEshAcFormGroup from "@/forms/registration/RegistrationHaveEshAcFormGroup";
import RegistrationLoginNameFormGroup from "@/forms/registration/RegistrationLoginNameFormGroup";
import RegistrationLoginNameNewFormGroup from "@/forms/registration/RegistrationLoginNameNewFormGroup";
import RegistrationPasswordNewFormGroup from "@/forms/registration/RegistrationPasswordNewFormGroup";
import RegistrationNameTitleFormGroup from "@/forms/registration/RegistrationNameTitleFormGroup";
import RegistrationFullNameFormGroup from "@/forms/registration/RegistrationFullNameFormGroup";
import RegistrationPasswordFormGroup from "@/forms/registration/RegistrationPasswordFormGroup";
import RegistrationEnglishNameFormGroup from "@/forms/registration/RegistrationEnglishNameFormGroup";
import RegistrationChineseNameFormGroup from "@/forms/registration/RegistrationChineseNameFormGroup";
import RegistrationContactAddressFormGroup from "@/forms/registration/RegistrationContactAddressFormGroup";
import RegistrationEmailFormGroup from "@/forms/registration/RegistrationEmailFormGroup";
import RegistrationLanguageFormGroup from "@/forms/registration/RegistrationLanguageFormGroup";
import CaptchaFormGroup from "@/forms/common/CaptchaFormGroup";
import ManageCertFormGroup from '@/pages/manage-cert/components/ManageCertFormGroup.vue';
import { v4 as uuidv4 } from 'uuid';
import AfterLinkedIAmSmart from "../../../login/components/login/AfterLinkedIAmSmart";
import AfterRegisterCompleted from '@/public/modules/login/components/login/AfterRegisterCompleted.vue';
import { translateResponseError } from "@/utils/translate-response-error";

export default {
  props: {
    invitationKey: {
      type: String,
    },
    businessId:{
      type: String
    }
  },
  components: {
    NxFormCaptcha,
    ERegistrationPublicTermCond,
    RegistrationHaveEshAcFormGroup,
    RegistrationLoginNameFormGroup,
    RegistrationPasswordFormGroup,
    RegistrationLoginNameNewFormGroup,
    RegistrationPasswordNewFormGroup,
    RegistrationEnglishNameFormGroup,
    RegistrationNameTitleFormGroup,
    RegistrationFullNameFormGroup,
    RegistrationChineseNameFormGroup,
    RegistrationContactAddressFormGroup,
    RegistrationEmailFormGroup,
    RegistrationLanguageFormGroup,
    CaptchaFormGroup,
    ManageCertFormGroup,
    AfterLinkedIAmSmart,
    AfterRegisterCompleted
  },
  data() {
    return {
      haveAc: true,
      form: this.getForm(),
      accepted: false,
      validCode: false,
      result: [],      
      nameEngDisable:false,
      guid:uuidv4(),
      fullName:"",
      linkIAmSmart: false,
      isCompleted:false,
      errorMsg: "",
    };
  },
   watch: {
  
  },
  async created(){
    console.log("created", this.invitationKey);
    if(this.invitationKey==null) this.invitationKey=this.$route.query.key;
    console.log("created 2", this.invitationKey);
    /*var res = await RequestRegistrationApi.validateInvitationCode(this.invitationKey)
    this.result = res.data;
    if(this.result == 'Valid')
    {
      this.validCode = true;
    }*/
  },  
  methods: {
    getForm() {
      return {
        username: "",
        password: "",
        nameEng: "",
        title: "Mr",
        surname: "",
        givenName: "",
        fullname:"",
        nameChinese: "",
        address: "",
        email: "",
        telephone: "",
        lang: "en",
        captcha: "",
        captchaToken: "",
        accepted: false,
      };
    },
    resetForm() {
      this.form = this.getForm();
      this.$refs.form.reset();
      this.$router.push({
        name:"Login"});
    },
    async onSubmit() {
      this.$spinner.show();
      const { haveAc, invitationKey, form } = this;
      if (haveAc) {
        try{
          await MemberRegistrationApi.loginOwner({
            LdapID:5,
            Username: form.username,
            Password: form.password,
            BusinessID: invitationKey,
            SessionKey: null
          });
          this.isCompleted=true;
        }
        catch ({response}) {
          if (response&&response.data) {
            this.errorMsg = translateResponseError(this, response.data);
            this.$dangerToast("Registration Error", this.errorMsg);
          }
        }
      } else {
          try{
            await MemberRegistrationApi.registerOwnerAssistant(
              {
                registrationProfileKey: "Owner",
                loginName: form.username,
                fullname: form.fullname,
                email: form.email,
                language: form.lang,
                propertyValues: {
                  guid: invitationKey,
                  chineseName: form.nameChinese,
                  contactAddress: form.address,
                  surname: form.fullname.trim(),
                  givenName: " ",
                  title: form.title
                },
                memberCertificationGUID:this.guid
              },
              this.businessId
            );
            this.$router.push({ name: "ERegistrationRegisterSuccess" });
          }
          catch ({response}) {
            if (response&&response.data) {
              console.log("response",response.data);
              this.errorMsg = translateResponseError(this, response.data);
              this.$dangerToast("Registration Error", this.errorMsg);
            }
          } 

        
      }
      this.$spinner.hide();
    },
    setFullName(certs)
    {
      if(certs!=null && certs.length>0)
      {
        this.form.fullname = certs[0].issuedTo;
      }
     
    },
   
    useESS() {
      this.$router.push({ name: 'Login' });
    }
  },
};
</script>

<style lang="scss" scoped></style>

<i18n src="@/locales/actions.locale"></i18n>

<i18n src="@/locales/responseMsg.locale"></i18n>

<i18n>
{
  "en": {
    "title": "Application for registration as an owner of Electronic Submission Hub",
    "titleDesc": "To become a registered user, please complete the following application form. All fields with (*) are mandatory.",
    "ownerLogin": "Login as Owner",
    "InvitationNotFound": "Invitation code not found or has been cancelled",
    "InvitationExpired": "Invitation code expired",
    "InvitationRegistered": "Invitation Code already registered"    
  },
  "zh_hk": {
    "title": "申請註冊為電子資料呈交及處理系統的業主/擁有人",
    "titleDesc": "要成為註冊用戶，請填寫以下申請表格。帶（*）的所有字段均為必填項。",
    "ownerLogin": "以業主/擁有人身份登錄",
    "InvitationNotFound": "邀請碼無效或已被取消",
    "InvitationExpired": "邀請碼已過期",
    "InvitationRegistered": "邀請碼已被使用"        
  },
  "zh_cn": {
    "title": "申请注册为电子资料呈交及处理系统的业主/拥有人",
    "titleDesc": "要成为注册用户，请填写以下申请表格。带（*）的所有字段均为必填项。",
    "ownerLogin": "以业主/拥有人身份登录",
    "InvitationNotFound": "邀请码无效或已被取消",
    "InvitationExpired": "邀请码已过期",
    "InvitationRegistered": "邀请码已被使用"    
  }
}
</i18n>
